var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spa-guest-treatments" },
    [
      _c("h3", { staticClass: "spa-guest-treatments__guest-name" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.guestNumber) +
            ". " +
            _vm._s(_vm.guestFirstName) +
            " " +
            _vm._s(_vm.guestLastName) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.filteredTreatments, function (treatment) {
        return _c(
          "div",
          {
            key: treatment.bookingId,
            staticClass: "spa-guest-treatments__treatment",
          },
          [
            _c(
              "div",
              { staticClass: "spa-guest-treatments__treatment-header" },
              [
                _c(
                  "h4",
                  { staticClass: "spa-guest-treatments__treatment-name" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(treatment.sitecoreTreatmentDetails.title) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "spa-guest-treatments__treatment-details" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "spa-guest-treatments__treatment-details__time",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getStartTime(
                                treatment,
                                _vm.guestNumber - 1,
                                true
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "spa-guest-treatments__treatment-details__category",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(treatment.treatmentCategory.title) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "spa-guest-treatments__treatment-details__duration",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(treatment.selectedTimeSlot.duration) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    treatment.selectedTimeSlot.preferredGender
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "spa-guest-treatments__treatment-details__therapist",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getGenderPreference(treatment)) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "p",
                          {
                            staticClass:
                              "spa-guest-treatments__treatment-details__therapist",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.tc(
                                    "spaSoft.step1.selectedTreatments.noGenderPreferenceLabel"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "spa-guest-treatments__treatment-price" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getTreatmentPriceFormatted({
                            treatment: treatment.selectedTimeSlot,
                            checkTaxes: true,
                            isReservation: true,
                          })
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "spa-guest-treatments__cancel" },
                  [
                    _c("spa-cancel-modal", {
                      attrs: {
                        treatment: treatment,
                        "guest-number": _vm.guestNumber - 1,
                        type: "treatment",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var activate = ref.activate
                              return _c("div", {}, [
                                !_vm.isReservationCancelled
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "spa-guest-treatments__cancel-btn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: activate,
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "space",
                                                  32,
                                                  $event.key,
                                                  [" ", "Spacebar"]
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return activate($event)
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return activate($event)
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.tc(
                                                "spaSoft.reservationdetails.cancelTreatmentCta"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }